import { Button, Stack, Typography } from '@mui/material';

import { useNextPrevEvent } from './useNextPrevEvent';

type NavigateButtonsProps = {
  handlePrev: () => void;
  handleNext: () => void;
  disabledPrev: boolean;
  disabledNext: boolean;
  prevLabel: string;
  nextLabel: string;
};

export const NavigateButtons = ({
  handleNext,
  handlePrev,
  disabledNext,
  disabledPrev,
  prevLabel,
  nextLabel,
}: NavigateButtonsProps) => {
  useNextPrevEvent(handleNext, handlePrev, disabledNext, disabledPrev);

  return (
    <Stack direction="row" alignItems="flex-start">
      <Button
        onClick={handlePrev}
        disabled={disabledPrev}
        sx={{
          color: 'text.primary',
          '&:hover': {
            backgroundColor: 'inherit',
          },
        }}
      >
        <Typography variant="body2">{prevLabel}</Typography>
      </Button>
      <Button
        onClick={handleNext}
        disabled={disabledNext}
        sx={{
          color: 'text.primary',
          '&:hover': {
            backgroundColor: 'inherit',
          },
        }}
      >
        <Typography variant="body2">{nextLabel}</Typography>
      </Button>
    </Stack>
  );
};
